<template>
  <div class="vid-int-audioTest" :class="{ 'vid-int-audioTest--videoresume': isVideoresume }">
    <div class="vid-int-audioTest__inner vid-int-audioTest__message">
      <div class="h2">
        {{ $tr('videoInterview.checkMicro.title') }}
      </div>

      <div class="vid-int-audioTest__content">
        {{ $tr('videoInterview.checkMicro.circularIndicator') }}
      </div>

      <div class="vid-int-audioTest__content grey-text">
        {{ $tr('videoInterview.checkMicro.accessToMicro') }}<br />
      </div>
    </div>

    <div class="vid-int-audioTest__inner vid-int-audioTest__img-container">
      <div class="vid-int-audioTest__progress">
        <svg
          class="vid-int-audioTest__micro-icon"
          width="78"
          height="121"
          viewBox="0 0 78 121"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M77.3995 62.4765C77.3995 60.0765 75.5642 58.2412 73.1642 58.2412C70.7642 58.2412 68.9289 60.0765 68.9289 62.4765C68.9289 78.9941 55.5172 92.4059 38.9996 92.4059C22.4819 92.4059 9.07019 78.9941 9.07019 62.4765C9.07019 60.0765 7.2349 58.2412 4.8349 58.2412C2.4349 58.2412 0.599609 60.0765 0.599609 62.4765C0.599609 82.1 15.2819 98.6176 34.7643 100.735V112.029H19.3761C16.9761 112.029 15.1408 113.865 15.1408 116.265C15.1408 118.665 16.9761 120.5 19.3761 120.5H58.6231C61.0231 120.5 62.8583 118.665 62.8583 116.265C62.8583 113.865 61.0231 112.029 58.6231 112.029H43.2348V100.735C62.7172 98.6176 77.3995 82.1 77.3995 62.4765Z"
            fill="currentColor"
          />
          <path
            d="M38.9998 0.5C26.0116 0.5 15.4233 11.0882 15.4233 24.0764V62.3352C15.4233 75.4646 26.0116 85.9117 38.9998 86.0528C51.988 86.0528 62.5762 75.4646 62.5762 62.4764V24.0764C62.5762 11.0882 51.988 0.5 38.9998 0.5Z"
            fill="currentColor"
          />
        </svg>

        <svg
          class="vid-int-audioTest__progress-svg svg-desktop"
          width="240"
          height="240"
          viewport="0 0 120 120"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            r="110"
            cx="120"
            cy="120"
            fill="transparent"
            stroke-dasharray="691.15"
            stroke-dashoffset="0"
          />
          <circle
            id="bar"
            ref="circle"
            r="110"
            cx="120"
            cy="120"
            fill="transparent"
            stroke-dasharray="691.15"
            stroke-dashoffset="0"
            :style="{ strokeDashoffset: currentArcDesktop }"
          />
        </svg>

        <svg
          class="vid-int-audioTest__progress-svg svg-tablet"
          width="176"
          height="176"
          viewport="0 0 88 88"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            r="78"
            cx="88"
            cy="88"
            fill="transparent"
            stroke-dasharray="490.08"
            stroke-dashoffset="0"
          />
          <circle
            id="bar"
            ref="circle"
            r="78"
            cx="88"
            cy="88"
            fill="transparent"
            stroke-dasharray="490.08"
            stroke-dashoffset="0"
            :style="{ strokeDashoffset: currentArcTablet }"
          />
        </svg>

        <svg
          class="vid-int-audioTest__progress-svg svg-mobile"
          width="136"
          height="136"
          viewport="0 0 68 68"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            r="58"
            cx="68"
            cy="68"
            fill="transparent"
            stroke-dasharray="364.42"
            stroke-dashoffset="0"
          />

          <circle
            id="bar"
            ref="circle"
            r="58"
            cx="68"
            cy="68"
            fill="transparent"
            stroke-dasharray="364.42"
            stroke-dashoffset="0"
            :style="{ strokeDashoffset: currentArcMobile }"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EquipmentCheckAudioTest',

    props: {
      micTestProgress: {
        type: Number,
        default: 0
      },

      isVideoresume: Boolean
    },

    computed: {
      currentArcDesktop() {
        return this.getArc(110);
      },

      currentArcTablet() {
        return this.getArc(78);
      },

      currentArcMobile() {
        return this.getArc(58);
      }
    },

    methods: {
      getArc(radius) {
        const c = Math.PI * (radius * 2);
        let val = this.micTestProgress;

        if (val <= 0) {
          return c;
        }

        if (val >= 100) {
          return 0;
        }

        const pct = ((100 - val) / 100) * c;

        return pct;
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .vid-int-audioTest {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    width: 100%;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;

    @media screen and (max-width: 1024px) {
      flex-direction: column-reverse;
    }
  }

  .vid-int-audioTest__message {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-width: 27.75rem; // 444px

    @media screen and (max-width: 1024px) {
      max-width: 100%;
      margin-top: 1rem;
    }
  }

  .vid-int-audioTest__img-container {
    display: flex;
  }

  .vid-int-audioTest__progress {
    width: 240px;
    height: 240px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    @media screen and (max-width: 1024px) {
      width: 176px;
      height: 176px;
    }

    @media only screen and (max-width: 480px) {
      width: 136px;
      height: 136px;
    }

    .vid-int-audioTest__micro-icon {
      position: absolute;
      width: 50px;
      font-size: 100px !important;
      color: #9faab6;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);

      @media screen and (max-width: 1024px) {
        zoom: 75%;
      }

      @media only screen and (max-width: 480px) {
        zoom: 60%;
      }
    }
  }

  .vid-int-audioTest__progress-svg {
    width: 240px;
    height: 240px;

    @media screen and (max-width: 1024px) {
      width: 176px;
      height: 176px;
    }

    @media only screen and (max-width: 480px) {
      width: 136px;
      height: 136px;
    }

    &.svg-tablet,
    &.svg-mobile {
      display: none;
    }

    @media screen and (max-width: 1024px) {
      &.svg-desktop {
        display: none;
      }

      &.svg-tablet {
        display: block;
      }
    }

    @media only screen and (max-width: 480px) {
      &.svg-tablet {
        display: none;
      }
      &.svg-mobile {
        display: block;
      }
    }

    circle {
      stroke-dashoffset: 0;
      transition: stroke-dashoffset 1s linear;
      stroke: $gray-basic;
      stroke-width: 6px;

      &#bar {
        stroke: $green;
        transform: rotate(270deg) translate(-240px, 0);

        @media screen and (max-width: 1024px) {
          transform: rotate(270deg) translate(-176px, 0);
        }

        @media only screen and (max-width: 480px) {
          transform: rotate(270deg) translate(-136px, 0);
        }
      }
    }
  }

  .vid-int-audioTest__inner {
    position: relative;
    margin-right: 1.5rem;

    @media screen and (max-width: 1024px) {
      margin-right: 0;
    }
  }

  .vid-int-audioTest__inner:last-child {
    margin-right: 0;
  }

  .vid-int-audioTest__content {
    font-size: $base-text-size;
    line-height: $base-text-line-height;
    font-weight: $base-font-weight;

    &:not(:last-child) {
      margin-bottom: 0.625rem; //10px
    }
  }

  .grey-text {
    color: $gray-hints;
  }

  .vid-int-audioTest--videoresume {
    .vid-int-audioTest__progress {
      .vid-int-audioTest__progress-svg {
        circle {
          color: #e7e7e7;

          &#bar {
            stroke: #a755d2;
          }
        }
      }
    }

    .vid-int-audioTest__micro-icon {
      color: #d1d8e0;
    }

    .h2 {
      margin-bottom: 16px;
      // font-family: 'Euclid Circular A';
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      color: #555555;
      text-transform: lowercase;
    }

    .vid-int-audioTest__content {
      // font-family: 'Euclid Circular A';
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 24px;
      color: #8d8d8d;

      &:not(:last-child) {
        margin-bottom: 0.625rem; //10px
      }

      &:last-child {
        color: #c4b9d3;
      }
    }
  }
</style>
